module.exports = __webpack_public_path__ + "static/scene-desk-761f82633c0f3dd8bb57e5a60a9f4ef7.jpg";